import { api } from './api';
import type {
  Prescription,
  PrescriptionWithRelations,
  CreatePrescriptionInput,
  SignedPrescription,
  VerifyPrescriptionResult,
  PaginatedResponse,
} from '@dpfs/shared';

export interface ListPrescriptionsParams {
  page?: number;
  limit?: number;
  status?: string;
  patientId?: string;
  fromDate?: string;
  toDate?: string;
}

export const prescriptionsService = {
  async create(input: CreatePrescriptionInput): Promise<Prescription> {
    const response = await api.post('/prescriptions', input);
    return response.data;
  },

  async list(
    params: ListPrescriptionsParams = {}
  ): Promise<PaginatedResponse<PrescriptionWithRelations>> {
    const response = await api.get('/prescriptions', { params });
    return response.data;
  },

  async getById(id: string): Promise<PrescriptionWithRelations> {
    const response = await api.get(`/prescriptions/${id}`);
    return response.data;
  },

  async sign(id: string): Promise<SignedPrescription> {
    const response = await api.post(`/prescriptions/${id}/sign`);
    return response.data;
  },

  async verify(id: string, hash: string, timestamp: number): Promise<VerifyPrescriptionResult> {
    const response = await api.get(`/prescriptions/${id}/verify`, {
      params: { h: hash, ts: timestamp },
    });
    return response.data;
  },

  async cancel(id: string): Promise<void> {
    await api.post(`/prescriptions/${id}/cancel`);
  },

  async getQRCode(id: string): Promise<{ qrCode: string; qrCodeUrl: string; expiresAt: string }> {
    const response = await api.get(`/prescriptions/${id}/qr`);
    return response.data;
  },

  async createShareLink(id: string): Promise<{ id: string; token: string; expiresAt: string }> {
    const response = await api.post(`/prescriptions/${id}/share`);
    return response.data;
  },

  async revokeShareLink(id: string, shareId: string): Promise<void> {
    await api.delete(`/prescriptions/${id}/share/${shareId}`);
  },

  async sendEmail(id: string): Promise<{ message: string; shareLink: { id: string; token: string; expiresAt: string } }> {
    const response = await api.post(`/prescriptions/${id}/send-email`);
    return response.data;
  },
};
